import type { SyntaxNode } from '@lezer/common';

/**
 * Get the text for the given range from the given codemirror text.
 * @internal
 */
export function getTextFromRange(
  { from, to }: { from: number; to: number } | SyntaxNode,
  doc?: string,
): string {
  if (!doc) {
    return '';
  }

  return doc.slice(from, to).toString();
}
